import { i as h, v as F, p as O, j as l, h as R } from "./UnstyledButton-ujNMaBde.js";
import "react";
import { I as p } from "./Button-CMUmoC07.js";
function g(s, r, t) {
  const e = h(s, r, t), {
    label: a,
    description: f,
    error: u,
    required: P,
    classNames: n,
    styles: i,
    className: j,
    unstyled: c,
    __staticSelector: m,
    __stylesApiProps: _,
    errorProps: A,
    labelProps: T,
    descriptionProps: B,
    wrapperProps: N,
    id: y,
    size: I,
    style: S,
    inputContainer: b,
    inputWrapperOrder: v,
    withAsterisk: W,
    variant: d,
    vars: G,
    mod: z,
    attributes: x,
    ...k
  } = e, { styleProps: q, rest: C } = F(k), E = {
    label: a,
    description: f,
    error: u,
    required: P,
    classNames: n,
    className: j,
    __staticSelector: m,
    __stylesApiProps: _ || e,
    errorProps: A,
    labelProps: T,
    descriptionProps: B,
    unstyled: c,
    styles: i,
    size: I,
    style: S,
    inputContainer: b,
    inputWrapperOrder: v,
    withAsterisk: W,
    variant: d,
    id: y,
    mod: z,
    attributes: x,
    ...N
  };
  return {
    ...C,
    classNames: n,
    styles: i,
    unstyled: c,
    wrapperProps: { ...E, ...q },
    inputProps: {
      required: P,
      classNames: n,
      styles: i,
      unstyled: c,
      size: I,
      __staticSelector: m,
      __stylesApiProps: _ || e,
      error: u,
      variant: d,
      id: y,
      attributes: x
    }
  };
}
const D = {
  __staticSelector: "InputBase",
  withAria: !0,
  size: "sm"
}, o = O((s, r) => {
  const { inputProps: t, wrapperProps: e, ...a } = g("InputBase", D, s);
  return /* @__PURE__ */ l.jsx(p.Wrapper, { ...e, children: /* @__PURE__ */ l.jsx(p, { ...t, ...a, ref: r }) });
});
o.classes = { ...p.classes, ...p.Wrapper.classes };
o.displayName = "@mantine/core/InputBase";
const w = R((s, r) => {
  const t = h("TextInput", null, s);
  return /* @__PURE__ */ l.jsx(o, { component: "input", ref: r, ...t, __staticSelector: "TextInput" });
});
w.classes = o.classes;
w.displayName = "@mantine/core/TextInput";
export {
  o as I,
  w as T,
  g as u
};
